module.exports = __webpack_public_path__ + "b113c76200461b1c22701bc0401aa0ee.png";